const tableOption = function () {
  return {
    view: "详情",
    stripe: true,
    page: true,
    maxHeight: "100%",
    align: "center",
    header: false,
    index: true,
    selection: true,
    emptyText: "暂无数据",
    column: [
      {
        label: "上报编号",
        prop: "reportCode",
        search: true,
        clearable: true
      },
      {
        label: "上报事件",
        prop: "reportName",
        search: true,
        clearable: true
      },
      {
        label: "报修设备",
        prop: "deviceName",
        search: true,
        clearable: true
      },
      {
        label: "厂家",
        prop: "factory",
      },
      {
        label: "紧急程度",
        prop: "reportLevel",
        search: true,
        clearable: true,
        type: "select",
        dicData: [
          {
            label: '特急',
            value: 1
          },
          {
            label: '紧急',
            value: 2
          },
          {
            label: '一般',
            value: 3
          }
        ],
        formatter: function (row, value) {
          if (Number(value) === 1) {
            return "特急";
          } else if (Number(value) === 2) {
            return "紧急";
          } else if (Number(value) === 3) {
            return "一般";
          }
          return "";
        }
      },
      {
        label: "状态",
        prop: "reportStates",
        search: true,
        clearable: true,
        type: "select",
        dicData: [
          {
            label: "待处理",
            value: 1
          },
          {
            label: "已取消",
            value: 2
          },
          {
            label: "处理中",
            value: 3
          },
          {
            label: "待确认",
            value: 4
          },
          {
            label: "已完成",
            value: 5
          }
        ],
        formatter: function (row, value) {
          if (Number(value) === 1) {
            return "待处理";
          } else if (Number(value) === 2) {
            return "已取消";
          } else if (Number(value) === 3) {
            return "处理中";
          } else if (Number(value) === 4) {
            return "待确认";
          } else if (Number(value) === 5) {
            return "已完成";
          }
          return "";
        }
      },
      {
        label: "上报日期",
        prop: "reportTime",
        search: true,
        clearable: true,
        type: "daterange"
      },
      {
        label: "上报人",
        prop: "personName"
      },
      {
        label: "手机号",
        prop: "phone"
      },
      {
        label: "位置",
        prop: "reportPosition"
      }
    ]
  };
};

export default tableOption;
